import React from 'react';
import { Box, Tooltip } from '@mui/material';
import SafeMarkdown from './SafeMarkdown';
import { markdownBodyCompactSx } from './markdownBodySx';

export const libraryTooltipPaperSx = {
  bgcolor: 'background.paper',
  color: 'text.primary',
  fontWeight: 400,
  border: 1,
  borderColor: 'divider',
  boxShadow: 3,
  borderRadius: 1,
  p: 0,
  maxWidth: 'none',
  '& .MuiTypography-root': { fontSize: '0.8125rem', lineHeight: 1.45 },
};

const tooltipMarkdownSx = {
  ...markdownBodyCompactSx,
  color: 'text.primary',
  fontSize: '0.8125rem',
  fontWeight: 400,
  lineHeight: 1.45,
  '& p': { mb: 0.5, color: 'inherit' },
  '& ul, & ol': { pl: 2.25, mb: 0.5 },
  '& strong, & b': { fontWeight: 700 },
  '& h1, & h2, & h3, & h4, & h5, & h6': {
    mt: 0.75,
    mb: 0.25,
    fontSize: '0.8125rem',
    lineHeight: 1.45,
    fontWeight: 600,
  },
};

export default function LibraryTooltip({ title, componentsProps, ...props }) {
  return (
    <Tooltip
      {...props}
      title={title ? (
        <Box sx={{ maxWidth: 300, p: 1.25, fontSize: '0.8125rem', lineHeight: 1.45 }}>
          {typeof title === 'string' ? (
            <SafeMarkdown sx={tooltipMarkdownSx}>{title}</SafeMarkdown>
          ) : title}
        </Box>
      ) : ''}
      componentsProps={{
        ...componentsProps,
        tooltip: {
          ...componentsProps?.tooltip,
          sx: { ...libraryTooltipPaperSx, ...componentsProps?.tooltip?.sx },
        },
        arrow: {
          ...componentsProps?.arrow,
          sx: { color: 'background.paper', ...componentsProps?.arrow?.sx },
        },
      }}
    />
  );
}
